import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { Grid, Card, CardMedia, CardContent, Typography, LinearProgress, createStyles, makeStyles, Theme, Box } from '@material-ui/core';
import { setExceptionHandler, setSamlBody, setSamlMethod, setRedirectAfterSignin, resetLaunch } from '@app/store/actions';
import { basicService, launchService, vaultPasswordsService } from '@app/services';
import { createTranslation } from '@app/helpers';
import { parse } from 'qs';
import { PageLoader } from '../../components';
import { handleSetSnackbar } from '../../store/actions/snackbar.actions';

const SharedPasswordRedirectPage = () => {
    const dispatch = useDispatch();

    const { translation } = useTypedTranslation();

    useEffect(() => {
        dispatch(setExceptionHandler(true));
        const location = window.location;
        const queryParams = parse(location.search, { ignoreQueryPrefix: true });

        if (queryParams.id === undefined ) {
            basicService.redirect('/passwords');
            return;
        }

        dispatch(setRedirectAfterSignin(window.location.pathname + location.search));

        vaultPasswordsService.getPasswordRedirectUrl(String(queryParams.id), handlePasswordRedirectResponse, handlePasswordRedirectError);

    }, []);

    const handlePasswordRedirectResponse = (response: any) => {
        dispatch(setRedirectAfterSignin(''));
        basicService.redirect(response.data.RedirectUrl);
    };

    const handlePasswordRedirectError = (error: any) => {
        dispatch(setRedirectAfterSignin(''));
        dispatch(handleSetSnackbar({ show: true, message: translation('VAULT_PASSWORD_REDIRECT_ERROR'), severity: 'error', dismissOnly: true }));
        basicService.redirect('/passwords');
    };

    return (
        <>
            <PageLoader />
        </>
    );
};

export default SharedPasswordRedirectPage;
